<template>
  <el-dialog :title="title" top="18vh" :visible.sync="generateInvoicedDialog"
    :width="generateInvoicedWidth" 
      :before-close="closeGenerateInvoiced">
    <div class="border"></div>
    <div class="invoiced-main">
      <div class="subject-details" :class="title === '手动拆分'?'subject-details-hand':''">
        <div class="hand-search" v-if="title === '手动拆分'">
          <el-input v-if="accountsType === 1" class="white w150" v-model="billHeadName" placeholder="请输入抬头" @input="subjectTableDataSearch"></el-input>
          <el-select v-else class="white w150" clearable v-model="searchProjectName" placeholder="请选择项目" @change="subjectTableDataSearch">
            <el-option
              v-for="item in projectList.filter(data => data.status)"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-select class="white w150"
            v-model="currencySystem" placeholder="请选择币制" @change="subjectTableDataSearch">
            <el-option v-for="item in currencySystemList" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
          <el-select class="white w150" filterable 
            v-model="subjectName" placeholder="请选择科目明细" @change="subjectTableDataSearch">
            <el-option v-for="item in subjectNameList" :key="item.name" :label="item.name"
              :value="item.name"></el-option>
          </el-select>
        </div>
        <el-select v-else class="white w150" filterable 
          v-model="subjectName" placeholder="请选择科目明细" @change="subjectTableDataSearch">
          <el-option v-for="item in subjectNameList" :key="item.name" :label="item.name"
            :value="item.name"></el-option>
        </el-select>
        <div class="table">
          <el-table 
          ref="table" 
          :data="filteredSubjectTableData" 
          style="width: 100%"
          @selection-change="handleSelectionSubjectChange"
          @sort-change="handleSortChange"
          >
            <el-table-column
              type="selection"
              width="30">
            </el-table-column>
            <el-table-column 
              v-for="(item,index) in subjectTableTitle" 
              :key="index" 
              :prop="item.prop" 
              :label="item.label"
              :width="item.width" 
              :sortable="item.prop === 'agentBusinessVal'?true:false"
              show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="arrow">
        <i class="el-icon-arrow-right" :class="selectSubjectDetails.length === 0 || editableTabs.length === 0?'is-disabled':''" @click="transmitInvoice"></i>
        <i class="el-icon-arrow-left" :class="selectInvoiceSubjectDetails.length === 0?'is-disabled':''" @click="transmitSubjectDetails"></i>
      </div>
      <div class="invoiced-details" :class="title === '手动拆分'?'invoiced-details-hand':''">
        <el-tabs v-model="editableTabsValue" type="card" editable @edit="handleTabsEdit">
          <el-tab-pane
            :key="item.name"
            v-for="(item, index) in editableTabs"
            :label="item.title"
            :name="item.name"
          >
            <div class="table">
              <el-table 
                ref="table" 
                :data="item.subjectTableData" 
                style="width: 100%"
                @selection-change="handleSelectionInvoiceSubjectChange"
              >
                <el-table-column
                  type="selection"
                  width="30">
                </el-table-column>
                <el-table-column 
                  v-for="(item,index) in subjectTableTitle" 
                  :key="index" 
                  :prop="item.prop" 
                  :label="item.label"
                  :width="item.width" 
                  show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>

          </el-tab-pane>

          <div class="select-invoice" v-if="selectInvoicedDialog" @click="handleClick">
            <el-radio-group v-model="selectInvoiceId" @input="inputRadio">
              <el-radio 
                v-for="(item, index) in openInvoicedGoodsServicesList"
                :key="index"
                :label="item.id"
              >
                <tool-tip v-bind="{ txtInfo: String(item.name) }">
                </tool-tip>
              </el-radio>
            </el-radio-group>
          </div>
        </el-tabs>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button class="btn-white" @click="closeGenerateInvoiced">取消</el-button>
      <el-button class="btn-blue" @click="saveGenerateInvoiced">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import toolTip from '@/components/base/toolTip.vue'
import CurrencyMinxins from "common/mixins/currency";
import InvoiceGoods from "common/mixins/invoice-goods";
import EntryExitInvoicing from "models/entry-exit-invoicing";
import InventoryReconciliation from "models/inventory-reconciliation";
import EnterExitWarehouseProjectMixins from 'common/mixins/enter-exit-warehouse-project'
export default {
  mixins: [CurrencyMinxins, InvoiceGoods, EnterExitWarehouseProjectMixins],
  components: {
    toolTip
  },
  props: {
    // 生成发票明细弹框开关
    generateInvoicedDialog: {
      type: Boolean,
      default: false
    },
    // 账单id集合
    billIds: {
      type: Array,
      default() {
        return []
      }
    },
    accountsType: {
      type: Number,
      default: null
    },
    projectId: {
      type: Number,
      default: null
    },
    projectName: {
      type: String,
      default: ''
    },
    // 弹框标题
    title: {
      type: String,
      default: ''
    },
    // 弹框宽带
    generateInvoicedWidth: {
      type: String,
      default: '916px'
    },
    // 科目明细表头
    subjectTableTitle: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      subjectName: '',
      billHeadName: '',
      currencySystem: '',
      searchProjectName: '',
      subjectNameList: [],
      // 搜索类型 exact:精确搜索； fuzzy:模糊搜索
      searchType: 'fuzzy',
      // 科目明细列表
      subjectTableData: [],
      // 筛选后科目明细列表
      filteredSubjectTableData: [],
      editableTabsValue: '1',
      editableTabs: [
        // {
        //   id: '',
        //   title: 'Tab 1',
        //   name: '1',
        //   subjectTableData: []
        // }
      ],
      tabIndex: 1,

      selectInvoicedDialog: false,
      // 选中的科目明细
      selectSubjectDetails: [],
      // 选中的科目明细（发票）
      selectInvoiceSubjectDetails: [],
      // 选中的发票id
      selectInvoiceId: null,
    }
  },

  created() {
    if (this.title === '生成发票明细') {
      this.initInvoicedGoodsServicesList();
      this.initSubjectDetailsList()
    }
    if (this.title === '手动拆分') {
      this.initHandSubjectDetailsList()
      if (this.accountsType === 2) {
        this.initEnterExitWarehouseProjectData();
      }
    }
    document.addEventListener('click', this.handleOutsideClick);
  }, 

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },

  methods: {
    /** 
     * @desc 科目明细列表
    */
    initSubjectDetailsList() {
      let id
      if (this.accountsType === 1) {
        id = Number(this.$route.query.entryExitInvoicingId)
      } else {
        id = Number(this.$route.query.inventoryReconciliationId)
      }
      EntryExitInvoicing.getInvoiceSubjectDetailsList(id).then(res => {
        if (res.success) {
          let arr = []
          let arr2 = []
          res.result.map(i => {
            let obj = {}
            let obj2 = {}
            obj2.name = i.feeName
            obj.id = i.id
            obj.invoiceId = i.invoiceId
            obj.invoiceDetailId = i.invoiceDetailId
            obj.feeName = i.feeName
            obj.keyword = i.keyword
            obj.orderNo = i.orderNo
            obj.currency = i.currency
            obj.currencyVal = this.currencySystemObj[i.currency]
            obj.price = i.price
            obj.localPrice = i.localPrice
            obj.orderType = i.orderType
            obj.entryExitNumber = i.orderNo
            obj.inboundOrderNo = i.inboundOrderNo
            obj.outboundOrderNo = i.outboundOrderNo
            arr.push(obj)
            arr2.push(obj2)
          })
          this.subjectTableData = arr
          this.subjectNameList = this.unique(arr2)
          this.filteredSubjectTableData = this.subjectTableData
        } else {
          this.$message.error(res.message);
        }
      });
    },
    
    /** 
     * @desc 手动拆分科目明细列表
    */
    initHandSubjectDetailsList() {
      let billIds = this.billIds
      let projectId = this.projectId
      let projectName = this.projectName
      let accountsType = this.accountsType
      let data = {
        billIds,
        projectId,
        projectName,
        accountsType
      }
      InventoryReconciliation.getFeeNameList(data).then(res => {
        if (res.success) {
          let arr = []
          let arr2 = []
          res.result.map((i, index) => {
            if (!i.isSplit) {
              let obj = {}
              let obj2 = {}
              obj2.name = i.feeName
              obj.id = index+1
              obj.isSplit = i.isSplit
              obj.currency = i.currency
              obj.currencyVal = this.currencySystemObj[i.currency]
              obj.feeName = i.feeName
              obj.keyword = i.keyword
              obj.isAddService = i.isAddService
              obj.orderFeeId = i.orderFeeId
              obj.price = i.price
              obj.orderType = i.orderType
              obj.orderNo = i.orderNo
              obj.inboundOrderNo = i.inboundOrderNo
              obj.outboundOrderNo = i.outboundOrderNo
              obj.entryExitNumber = i.orderNo
              obj.billId = i.billId
              obj.billHeadId = i.billHeadId
              obj.billHeadName = i.billHead ? `${i.billHead.name}` : ''
              obj.projectId = i.projectId
              obj.projectName = i.projectName
              obj.agentBusiness = i.agentBusiness
              obj.agentBusinessVal = i.agentBusiness ? '是' : '否';
              arr.push(obj)
              arr2.push(obj2)
            }
          })
          this.subjectTableData = arr
          this.subjectNameList = this.unique(arr2)
          this.filteredSubjectTableData = this.subjectTableData
        } else {
          this.$message.error(res.message);
        }
      });
    },

    
    /** 
     * @desc 去重(后面替换前面的)
    */
    unique(arr) {
      let res = []
      let map = new Map()
      for (let i of arr) {
        map.set(i.name, i)
      }
      res = [...map.values()]
      return res
    },

    closeGenerateInvoiced() {
      this.$emit('onCloseGenerateInvoiced')
    },

    saveGenerateInvoiced() {
      if (this.title === '生成发票明细') {
        if (this.subjectTableData.length !== 0) return this.$message.error('请先分配完科目明细');
      } else {
        let isFlag = false
        let title = ''
        this.editableTabs.map(i => {
          if (i.subjectTableData.length === 0) {
            isFlag = true
            title = i.title
          }
        })
        if (isFlag) return this.$message.error(`${title}不能为空`);
      }
      this.$emit('onSaveGenerateInvoiced', this.editableTabs)
    },

    handleTabsEdit(targetName, action) {
      if (action === 'add') {
        if (this.title === '生成发票明细') {
          this.selectInvoicedDialog = true
        } else {
          let newTabName = `${this.editableTabs.length+1}`;
          this.editableTabs.push({
            id: '',
            title: `分组${newTabName}`,
            goodsReceiptName: '',
            name: newTabName,
            subjectTableData: []
          });
          this.editableTabsValue = newTabName;
        }
      }
      if (action === 'remove') {
        this.$confirm("是否删除该分组？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-blue',
          cancelButtonClass: 'btn-white'
        })
          .then(() => {
            let tabs = this.editableTabs;
            let activeName = this.editableTabsValue;
            if (activeName === targetName) {
              tabs.forEach((tab, index) => {
                if (tab.name === targetName) {
                  let nextTab = tabs[index + 1] || tabs[index - 1];
                  if (nextTab) {
                    activeName = nextTab.name;
                  }
                }
              });
            }
            
            this.editableTabsValue = activeName;
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                this.subjectTableData = [...this.subjectTableData, ...tab.subjectTableData]
                this.filteredSubjectTableData = this.subjectTableData
              }
            })
            this.editableTabs = tabs.filter(tab => tab.name !== targetName);
            this.subjectTableDataSearch()
          })
          .catch(() => {});
      }
    },

    /** 
     * @description 添加发票
    */
    inputRadio(v) {
      let obj = this.openInvoicedGoodsServicesList.find(item => {return item.id == v})
      let newTabName = ++this.tabIndex + '';
      this.editableTabs.push({
        id: obj.id,
        title: this.title === '手动拆分'?`分组${newTabName-1}`:obj.name,
        goodsReceiptName: obj.name,
        name: newTabName,
        subjectTableData: []
      });
      this.editableTabsValue = newTabName;
      this.selectInvoicedDialog = false
    },

    handleClick(event) {
      event.stopPropagation();
    },

    handleOutsideClick(event) {
      // 阻止触发按钮区域的点击事件，否则将打不开弹窗
      if (event.target.classList.contains('el-tabs__new-tab') || event.target.classList.contains('el-icon-plus')) {
        return
      }
      // 打开弹窗并且点击了其他区域，关闭弹窗
      if (this.selectInvoicedDialog && !event.target.classList.contains('select-invoice')) {
        this.selectInvoicedDialog = false;
      }
    },

    /** 
     * @description 选中的科目明细
    */
    handleSelectionSubjectChange(val) {
      this.selectSubjectDetails = val;
    },

    /** 
     * @description 选中的科目明细（发票）
    */
    handleSelectionInvoiceSubjectChange(val) {
      this.selectInvoiceSubjectDetails = val;
    },

    /** 
     * @description 选中的科目明细穿梭到发票科目明细中
    */
    transmitInvoice() {
      if (this.selectSubjectDetails.length === 0) {
        return this.$message.error('请先选择费用明细');
      }
      if (this.editableTabs.length === 0) {
        return this.$message.error('请先创建分组');
      }
      if (this.selectSubjectDetails.length && this.editableTabs.length) {
        let currencyFlag = false
        let agentBusinessFlag = false
        let billHeadFlag = false
        this.selectSubjectDetails.map(i => {
          this.editableTabs.map(j => {
            if (j.name === this.editableTabsValue) {
              if (j.subjectTableData.length === 0) {
                j.subjectTableData.push(i)
              } else {
                j.subjectTableData.map(p => {
                  if (p.billHeadId !== i.billHeadId) billHeadFlag = true
                  if (p.agentBusiness !== i.agentBusiness) agentBusinessFlag = true
                  if (p.currency !== i.currency) currencyFlag = true
                })
                if (!billHeadFlag && !agentBusinessFlag && !currencyFlag) j.subjectTableData.push(i)
              }
            }
          })

          if (billHeadFlag) return this.$message.error('该分组下抬头不一致');
          if (agentBusinessFlag) return this.$message.error('该分组下代收代付不一致');
          if (currencyFlag) return this.$message.error('该分组下币值不一致');
          if (!billHeadFlag && !agentBusinessFlag && !currencyFlag) {
            this.subjectTableData = this.subjectTableData.filter(item => item.id !== i.id)
          }
        })
        this.filteredSubjectTableData = this.subjectTableData
      }
    },
    
    /** 
     * @description 选中的发票科目明细穿梭到科目明细中
    */
    transmitSubjectDetails() {
      if (this.selectInvoiceSubjectDetails.length === 0) {
        return this.$message.error('请先选择分组下的费用明细');
      }
      if (this.selectInvoiceSubjectDetails.length) {
        this.selectInvoiceSubjectDetails.map(i => {
          this.subjectTableData.push(i)
          this.editableTabs.map(j => {
            if (j.name === this.editableTabsValue) {
              j.subjectTableData = j.subjectTableData.filter(item => item.id !== i.id)
            }
          })
        })
        
        this.filteredSubjectTableData = this.subjectTableData
      }
    },
    
    /** 
     * @description 排序
    */
    handleSortChange({ column, prop, order }) {
      if (prop === 'agentBusinessVal') { 
        this.subjectTableData.sort((a, b) => {
          return order === 'ascending' ? a.agentBusiness - b.agentBusinessVal : b.agentBusinessVal - a.agentBusinessVal;
        });
      }
    },

    /** 
     * @description 科目明细列表静态搜索
    */
    subjectTableDataSearch() {
      // 当搜索文本或搜索类型发生变化时，触发筛选逻辑
      if (this.title === '手动拆分') {
        if (this.accountsType === 1) {
          if (!this.billHeadName && !this.currencySystem && !this.subjectName) {
            // 如果没有搜索文本，显示所有数据
            this.filteredSubjectTableData = this.subjectTableData;
            return;
          }
        } else {
          if (!this.searchProjectName && !this.currencySystem && !this.subjectName) {
            // 如果没有搜索文本，显示所有数据
            this.filteredSubjectTableData = this.subjectTableData;
            return;
          }
        }
      } else {
        if (!this.subjectName) {
          // 如果没有搜索文本，显示所有数据
          this.filteredSubjectTableData = this.subjectTableData;
          return;
        }
      }
      this.filteredSubjectTableData = this.subjectTableData.filter((item) => {
        let lowerBillHeadName = ''
        let billHeadName = ''
        let lowerSearchProjectName = ''
        let projectName = ''
        let lowerCurrencySystem = ''
        let currency = ''
        let lowerSubjectName = ''
        let feeName = ''
        lowerSubjectName = this.subjectName.toLowerCase(); // 将搜索文本转换为小写，以便进行大小写不敏感的比较
        feeName = item.feeName.toLowerCase(); // 将科目明细字段转换为小写
        if (this.title === '手动拆分') {
          if (this.accountsType === 1) {
            lowerBillHeadName = this.billHeadName.toLowerCase(); // 将搜索文本转换为小写，以便进行大小写不敏感的比较
            billHeadName = item.billHeadName.toLowerCase(); // 将抬头名称字段转换为小写
          } else {
            lowerSearchProjectName = this.searchProjectName.toLowerCase(); // 将搜索文本转换为小写，以便进行大小写不敏感的比较
            projectName = item.projectName.toLowerCase(); // 将项目名称字段转换为小写
          }
  
          lowerCurrencySystem = this.currencySystem.toLowerCase(); // 将搜索文本转换为小写，以便进行大小写不敏感的比较
          currency = item.currency.toLowerCase(); // 将币制字段转换为小写
        }

        if (this.searchType === "fuzzy") {
          // 模糊筛选
          if (this.title === '手动拆分') {
            if (this.accountsType === 1) {
              return billHeadName.includes(lowerBillHeadName) && currency.includes(lowerCurrencySystem) && feeName.includes(lowerSubjectName);
            } else {
              return projectName.includes(lowerSearchProjectName) && currency.includes(lowerCurrencySystem) && feeName.includes(lowerSubjectName);
            }
          } else {
            // 检查科目明细字段是否包含搜索文本
            return feeName.includes(lowerSubjectName);
          }
        } else if (this.searchType === "exact") {
          // 精确筛选
          if (this.title === '手动拆分') {
            if (this.accountsType === 1) {
              return billHeadName === lowerBillHeadName && currency === lowerCurrencySystem && feeName === lowerSubjectName;
            } else {
              return projectName === lowerSearchProjectName && currency === lowerCurrencySystem && feeName === lowerSubjectName;
            }
          } else {
            // 检查科目明细字段是否完全匹配搜索文本
            return feeName === lowerSubjectName;
          }
        }
        return false; // 如果不符合任何筛选条件，返回 false，表示该数据不显示
      });
    },
  }
}
</script>

<style lang='scss'>
.el-dialog {
  .el-dialog__header {
    padding-left: 20px;
  }

  .el-dialog__body {
    .border {
      border-color: #EEEEEE;
      margin-bottom: 0px
    }
    
    .table .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(1) .cell,
    .table .el-table .el-table__body-wrapper .el-table__body tr td:nth-of-type(1) .cell {
      padding-left: 10px;
      padding-right: 4px;
    }
    .table .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(2) .cell,
    .table .el-table .el-table__body-wrapper .el-table__body tr td:nth-of-type(2) .cell {
      padding-left: 2px;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner,
    .el-checkbox__inner:hover {
      border-color: #2E68EA;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner, 
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2E68EA;
      border-color: #2E68EA;
    }
    .invoiced-main {
      height: 352px;
      padding: 20px 0px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .subject-details {
        width: 420px;
        height: 100%;
        display: flex;
        flex-direction: column;
        .table {
          flex: 1;
          overflow: auto;
        }
        .hand-search {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .w150 {
          width: 150px;
          margin-bottom: 10px;
          margin-right: 20px;
        }
      }
      .arrow {
        width: 36px;
        display: flex;
        flex-direction: column;
        align-items: center;
        i {
          width: 20px;
          height: 20px;
          background: #2E68EA;
          color: white;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .el-icon-arrow-right {
          margin-bottom: 4px;
        }
        .is-disabled {
          background: #FAFAFA;
          border: 1px solid #CCCCCC;
          color: #CFCFCF;
        }
      }
      .invoiced-details {
        width: 420px;
        height: 100%;
        display: flex;
        flex-direction: column;
        .el-tabs {
          position: relative;
          .el-tabs__content {
            overflow: inherit;
            .el-table {
              height: 269px;
              overflow: auto;
            }
          }
        }
        .el-tabs__new-tab {
          width: 30px;
          height: 31px;
          margin: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 4px 4px 0px 0px;
          border-bottom: none;
          .el-icon-plus {
            font-size: 20px;
            color: #999;
          }
        }
        .el-tabs__header {
          margin-bottom: 10px;
        }
        .el-tabs__item {
          height: 31px;
          line-height: 32px;
          font-weight: 400;
          font-size: 14px;
          font-family: 'PingFang SC-Regular';
        }
        .el-tabs__item.is-closable {
          color: #666;
          background: #FAFAFA;
          border-bottom: 1px solid #EEEEEE;
        }
        .el-tabs__item.is-active {
          color: #2E68EA;
          background: white;
          border-bottom: 0px;
        }
        .el-tabs__item:focus.is-active.is-focus:not(:active) {
          box-shadow: inherit;
        }
        .el-tabs__nav-next, .el-tabs__nav-prev {
          line-height: 30px;
        }
        .el-tabs__nav-scroll {
          height: 32px;
        }

        .select-invoice {
          position: absolute;
          top: -8px;
          right: 0px;
          width: 204px;
          height: 136px;
          z-index: 9999;
          overflow-y: auto;
          background: #FFFFFF;
          box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #EBEEF5;
          padding: 4px 6px;
          box-sizing: border-box;
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width : 4px;  /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 4px;
            box-shadow: inset 0 0 5px #EEEEEE;
            background: #EEEEEE;
          }
          .el-radio-group {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            .el-radio {
              height: 30px;
              line-height: 30px;
              margin-right: 0px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .el-radio__label {
                width: 168px;
                box-sizing: border-box;
                padding: 0px 4px;
                // overflow : hidden;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-line-clamp: 1;
                // -webkit-box-orient: vertical;
              }
            }
            .el-radio__input.is-disabled.is-checked .el-radio__inner,
            .el-radio__input.is-checked .el-radio__inner {
              background-color: #2E68EA;
              border-color: #2E68EA;
            }
            .el-radio__inner:hover {
              border-color: #2E68EA;
            }
            .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
            .el-radio__inner::after {
              background-color: white;
            }
            .el-radio__label,
            .el-radio__input.is-checked+.el-radio__label {
              font-weight: 400;
              font-size: 12px;
              color: #333333;
              font-family: 'PingFang SC-Regular';
            }
          }
        }
      }
      .subject-details-hand,
      .invoiced-details-hand {
        width: 540px;
        .table .el-table .el-table__header-wrapper .el-table__header tr th .cell {
          padding: 8px 5px;
        }
        .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
          padding-left: 5px;
        }
    
        .table .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(1) .cell,
        .table .el-table .el-table__body-wrapper .el-table__body tr td:nth-of-type(1) .cell {
          padding-left: 10px;
          padding-right: 4px;
        }
        .table .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(2) .cell,
        .table .el-table .el-table__body-wrapper .el-table__body tr td:nth-of-type(2) .cell {
          padding-left: 2px;
        }
        .caret-wrapper {
          height: 16px;
        }
        .sort-caret.ascending {
          top: -4px;
        }
        .sort-caret.descending {
          bottom: -2px;
        }
      }
    }
  }

  .dialog-footer {
    padding-bottom: 20px;
    border-top: 1px solid #f7f7f7;
    padding-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
